import { render, staticRenderFns } from "./InvoicesTab.vue?vue&type=template&id=e1194484&scoped=true&"
import script from "./InvoicesTab.vue?vue&type=script&lang=ts&"
export * from "./InvoicesTab.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicesTab.vue?vue&type=style&index=0&id=e1194484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1194484",
  null
  
)

export default component.exports